// extracted by mini-css-extract-plugin
export default {"item":"CompanyDetailForm_item__UB9dK","notes":"CompanyDetailForm_notes__IktGl","link":"CompanyDetailForm_link__rs4db","input":"CompanyDetailForm_input__V0Nw5"};